<template>
    <div class="jump-usercenter nav-bar-fixed">
        <van-nav-bar title="消息通知" left-arrow fixed   @click-left="back">
        </van-nav-bar>
        <div class="cont">
            {{message}}
        </div>
         <div class="app-bottom">
            <van-tabbar v-model="tabActive" active-color="#3c6eeb">
                <van-tabbar-item url="#/home">
                    <i slot="icon" class="iconfont icon-shouye"></i>
                    首页
                </van-tabbar-item>
                <van-tabbar-item icon="label-o" url="#/cate">
                    <i slot="icon" class="iconfont icon-icon-"></i>
                    分类
                </van-tabbar-item>
                <van-tabbar-item icon="label-o" url="#/message">
                    <i slot="icon" class="iconfont icon-ico_msg"></i>
                    消息
                </van-tabbar-item>
                <van-tabbar-item icon="cart-o" url="#/cart">
                    <i slot="icon" class="iconfont icon-gouwuche1"></i>
                    购物车
                </van-tabbar-item>
                <van-tabbar-item icon="contact" url="#/usercent">
                    <i slot="icon" class="iconfont icon-ziyuan2"></i>
                    我的
                </van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>
<script>
    import {NavBar,Tabbar,TabbarItem} from "vant";

    export default {
        name: "message",
        components: {
            [NavBar.name]: NavBar,
             [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
        },
        data() {
            return {
                message:this.$route.query.message,
                tabActive:2
            };
        },
        methods: {
            back() {
                this.$router.replace('/home');
            },
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-nav-bar-rhd {
        color: #fff;
        font-size: 16px;
        i {
            font-size: 20px;
        }
        span {
            margin-left: 5px;
        }
        span,
        i {
            vertical-align: middle;
        }
    }
    .van-nav-bar__text {
        font-size: 16px;
        padding: 0;
        margin: 0;
    }
    .cont{
        padding:14px;
        text-indent:20px;
    }
</style>